import React, { useCallback, useEffect, useState } from 'react';

import cx from 'classnames';

import { detectIOS } from '@zola-helpers/client/dist/es/util/detectBrowser';
import getEnvironment, { EnvironmentTypes } from '@zola-helpers/client/dist/es/util/environment';
import { getSessionStorage, setSessionStorage } from '@zola-helpers/client/dist/es/util/storage';
import { XIcon } from '../SvgIconsV3/X';
import ZolaLogo from '../ZolaLogo/ZolaLogo';
import { COLORS3 } from '../../styles/emotion';

import styles from './appDownloadBannerMobile.module.less';

const SESSION_STORAGE_KEY = 'zolaAppDownloadBannerHidden';

export interface AppDownloadBannerMobileProps {
  className?: string;

  /**
   * Show the banner regardless of session storage or browser width (used for testing)
   */
  show?: boolean;
}

export const AppDownloadBannerMobile = ({
  className,
  show = false,
}: AppDownloadBannerMobileProps) => {
  const [hidden, setHidden] = useState(true);
  const [shown, setShown] = useState(show);

  useEffect(() => {
    const isIOS = detectIOS();
    const wasHiddenByUser = getSessionStorage(SESSION_STORAGE_KEY) === 'true';
    setHidden(!isIOS || wasHiddenByUser);
  }, []);

  const hide = useCallback(() => {
    setHidden(true);
    setShown(false);
    setSessionStorage(SESSION_STORAGE_KEY, 'true');
  }, []);

  const open = useCallback(() => {
    const { pathname, search } = window.location;
    const base =
      getEnvironment() === EnvironmentTypes.PRODUCTION
        ? 'https://native.zola.com'
        : 'https://qa-native.zola.com';
    const nativeUrl = new URL(`${pathname}${search}`, base).href;
    window.location.assign(nativeUrl);
  }, []);

  return (
    <div
      className={cx(
        styles.appDownloadBannerMobile,
        { [styles.hidden]: hidden, [styles.shown]: shown },
        className
      )}
    >
      <button className={styles.hideButton} onClick={hide}>
        <XIcon width={16} height={16} color={COLORS3.BLACK_030} />
      </button>
      <div className={styles.appIcon}>
        <ZolaLogo className={styles.logo} type="heart" color={COLORS3.SKY_100} />
      </div>
      <div className={styles.appInfo}>
        <div className={styles.heading}>It&rsquo;s easier on the Zola app</div>
        <div className={styles.subheading}>Open in the Zola app</div>
      </div>
      <button className={styles.openButton} onClick={open}>
        OPEN
      </button>
    </div>
  );
};
